import { render, staticRenderFns } from "./Imagens.vue?vue&type=template&id=5a295d68&scoped=true"
import script from "./Imagens.vue?vue&type=script&lang=js"
export * from "./Imagens.vue?vue&type=script&lang=js"
import style0 from "./Imagens.vue?vue&type=style&index=0&id=5a295d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a295d68",
  null
  
)

export default component.exports